// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-commerce__inner[data-v-168e110e]{position:relative}@media(max-width:599px){.e-commerce__header[data-v-168e110e]{flex-direction:column;align-items:flex-start!important;gap:12px}}.e-commerce__no-results[data-v-168e110e]{max-width:100%}", ""]);
// Exports
module.exports = exports;
